import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit,
    ElementRef, 
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiEndPointConstants } from 'merlin-core';
import { TermsConditionsService } from './terms-conditions.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
    PopupConfig,
    PopupService,
    PopupType,
    UserProfileObject,
    UserService,
} from 'merlin-library';
import { LocalizationService, LanguageSource, ReturnType } from 'src/core/utilitites/localization.service';
import { IdentifierService } from 'merlin-core';
import { InputSecurityService } from 'src/app/services/input-security.service';
import { FormSecurityValidationService } from 'src/core/utilitites/form-security-validation.service';
import { environment } from 'src/environments/environment';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { MsalService } from '@azure/msal-angular';

let proxy;
@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    standalone: false
})
export class TermsConditionsComponent implements OnInit, AfterViewInit {
    userRecordId: number;
    isScroll = false;
    privacyChecked: boolean = false;
    @ViewChild('tcPdfViewer') tcPdfViewer: PdfJsViewerComponent;
    name = new UntypedFormControl('', Validators.required);
    footerData: any = [
        {
            url: '/terms-of-use',
            link: 'label.gb.terms_cond',
            clickFunction: this.websiteTermsClick,
        },
        {
            url: '/privacy-policy',
            link: 'label.gb.priv_policy',
            clickFunction: this.privacyPolicyClick,
            showClick: true,
        },
        {
            url: '/contact-us',
            link: 'label.gb.contact_us',
            clickFunction: this.contactUsClick,
        },
        {
            url: '/cardio-vascular',
            link: 'www.cardiovascular.abbott',
            clickFunction: this.websiteMoreInfoClick,
            showClick: true,
        },
    ];
    currentYear: number = new Date().getFullYear();
    footerCopyRights: any = [
        { linkText: `Merlin.net\u2122 \u00A9 ${this.currentYear} Abbott` },
    ];
    fooMenuClass = '';
    fooCopyrightClass = '';
    userProfile: UserProfileObject;
    url: string;
    clinicCountry: string = 'US';
    payload: { termsAndCondAcceptanceFlg: boolean; privacyNoticeAcceptanceFlg: boolean };
    disableButton = false;
    signature: any;
    validateScroll = [];
    isTcPdfLoaded: boolean = false;
    returnUrl: any;
    locale;
    constructor(
        private router: Router,
        private tncService: TermsConditionsService,
        public popupService: PopupService,
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private userService: UserService,
        private msalService: MsalService,
        private ele: ElementRef,
        private route: ActivatedRoute,
        private inputSecurityService: InputSecurityService,
        private formSecurityService: FormSecurityValidationService
    ) {}
    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key, '', 'html');
    }
    ngOnInit(): void {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || ApiEndPointConstants.quickLinkDashboardURL;
        this.name.valueChanges.subscribe((inpt) => {
            this.signature = inpt;
            this.checkUserScroll();
        });
    }
    mustBeSigned() {
        const [tNc, pn] = [this.translate('label.gb.signTnC'), this.translate('label.gb.signPN')];
        const urlTnc = "<a href='https://www.cardiovascular.abbott/int/en/policies/merlin-net/merlin-net-terms-of-use.html' target='_blank'>" + tNc + "</a>"
        const urlPn = "<a href='https://www.cardiovascular.abbott/int/en/policies/merlin-net.html' target='_blank'>" + pn + "</a>"
        let returnString = this.localizationService.generateLocalizedStr(`label.gb.terms_cond_must_be_signed`,
            { 0: urlTnc, 1: urlPn }, ReturnType.HTML);
        returnString = returnString.replace(/{tm}/g, '&trade;');
        return returnString;
    }

    ngAfterViewInit() {
        proxy = this;
        this.userService
            .getUserProfile(false)
            .subscribe((userProfile: UserProfileObject) => {
                this.userProfile = userProfile;
                this.locale = userProfile?.locale;
                if (!this.userProfile) {
                    this.router.navigateByUrl('/base');
                } else {
                    this.localizationService.setLanguage(
                        LanguageSource.UserDefined,
                        this.locale
                    );
                    let path;
                    //Load Default if user profile not having path
                    if (!this.userProfile?.clinicCountry) {
                        path = '/ClinicTermsAndConditions/Clinic_Terms_and_Conditions_US.pdf';
                    } else {
                        path = `/ClinicTermsAndConditions/Clinic_Terms_and_Conditions_${this.userProfile?.clinicCountry}.pdf`;
                    }
                    
                    this.url =
                        environment.disclosureUrl +
                        path +
                        '#menubar=0&location=0&toolbar=0&navpanes=0&resizable=0&status=1&scrollbars=0&zoom=page-width';
                  //  this.url = "http://localhost:4200/assets/Clinic_Terms_and_Conditions_AT.pdf"
                    this.fetchPdf();
                }
            });
    }
    // Fetch pdf 
    async fetchPdf(){
        try{
            // let pdfControlLocale = this.locale?.split('_');
        this.tcPdfViewer.pdfSrc = this.url;
        // this.tcPdfViewer.locale = pdfControlLocale[0];
        this.tcPdfViewer.refresh();
        } catch{ }
    }
    
    // To read the pdf loading.
    pdfLoaded() {
        this.isTcPdfLoaded = true;
        if (this.isTcPdfLoaded) {
            this.accessIfrScroll();
        }
    }

    checkDisable(){
        let scrollComplete = sessionStorage.getItem('isScrollCompletedTC') ? JSON.parse(sessionStorage.getItem('isScrollCompletedTC')) : false;
        
        return !(scrollComplete && this.privacyChecked && this.signature);
    }
    // To access pdf co-ordinates.
    accessIfrScroll() {
        var iFrameWindow: any =
            this.ele.nativeElement.getElementsByTagName('ng2-pdfjs-viewer')[0]
                ?.children[0]['contentWindow'];
        var container = iFrameWindow.document.getElementById('viewerContainer');
        container.addEventListener('scroll', (e) => {
            let isScroll =
                Math.ceil(container.offsetHeight + container.scrollTop) + 20 >=
                container.scrollHeight
                    ? true
                    : false;
            this.validateScroll.push(isScroll);
            let currentTCState = JSON.parse(
                sessionStorage.getItem('isScrollCompletedTC')
            );
            if (currentTCState === null || currentTCState === false) {
                sessionStorage.setItem(
                    'isScrollCompletedTC',
                    isScroll.toString()
                );
            }
            // To enable the btn on touching the pdf ground.
            if (
                this.name.value !== '' &&
                (this.validateScroll.includes(true) || currentTCState)
                && this.privacyChecked
            ) {
                let btn = document.getElementById(
                    'acceptBtn'
                ) as HTMLButtonElement;
                this.disableButton = true;
                //btn.disabled = false;
                
            } else {
                this.disableButton = false;
            }
        });
    }
    onBlur(e) {
        this.signature = e.target.value;
        this.checkUserScroll();
    }
    checkUserScroll() {
        if (this.signature && this.privacyChecked) {
           
            let scrollCmpleted = JSON.parse(
                sessionStorage.getItem('isScrollCompletedTC')
            );
            this.disableButton =
                scrollCmpleted !== null ? scrollCmpleted : false;
        } else {
            
            this.disableButton = false;
            
        }
    }
    acceptBtn() {
        if (this.inputSecurityService.containsThreat(this.name.value)) {
            const fieldLabel = this.localizationService.generateLocalizedStr('label.gb.enter_name');
            this.formSecurityService.notifyThreats([fieldLabel]);
            return;
        }

        this.payload = {
            termsAndCondAcceptanceFlg: true,
            privacyNoticeAcceptanceFlg : this.privacyChecked
        };
        this.tncService
            .setUserConsent(this.userProfile?.userRecordId, this.payload)
            .subscribe((res) => {
                window?.scrollTo(0, 0);
                window.sessionStorage.setItem('terms', 'true')
                sessionStorage.removeItem('isScrollCompletedTC');
                this.router.navigateByUrl(this.returnUrl);
            });
    }
    declineBtn() {
        const readAgain: PopupConfig = this.readAgainRef(
            this.translate('msg.lo817.text'),
            PopupType.Confirm
        );
        const gotoLogin: PopupConfig = this.declineRef(
            this.translate('msg.lo819.text'),
            PopupType.Prompt
        );
        this.popupService.open(readAgain);
        this.popupService.dialogRef.afterClosed().subscribe((review : boolean)=>{
            if(!review){
            this.popupService.open(gotoLogin);
            this.popupService.confirmed().subscribe((res) => {
                window.sessionStorage.clear();
                this.msalService.logoutRedirect({postLogoutRedirectUri: '/'});
            });
        }
        })

    }
    readAgainRef(message: string, type: PopupType) {
        const msg = this.translate(message);
        const dialogConfig: PopupConfig = {
            type: type,
            message: msg,
            confirmText: this.translate(
                'label.gb.ok'
            ),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText: this.translate(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
        return dialogConfig;
    }
    declineRef(message: string, type: PopupType) {
        const msg = this.translate(message);
        const dialogConfig: PopupConfig = {
            type: type,
            message: msg,
            confirmText: this.translate(
                'label.gb.ok'
            ),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText: this.translate(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
        return dialogConfig;
    }
    //footer links
    websiteTermsClick() {
        window.open(
            environment.disclosureUrl + '/Terms_and_Conditions.pdf',
            '_blank'
        );
    }

    privacyPolicyClick() {
        window.open(
            environment.disclosureUrl + '/Privacy_Policy.pdf',
            '_blank'
        );
    }
    contactUsClick() {
        const title = 'Contact Information';
        var win = window.open(
            '',
            'UATRpt',
            'menubar=0,location=0,toolbar=0,resizable=1,status=1,scrollbars=1'
        );

        if (win.document) {
            win.document.write(
                '<html><head><title>' +
                    title +
                    '</title></head><body><img src="' +
                    environment.disclosureUrl +
                    '/' +
                    'contact_us_text.gif' +
                    '" width="70%"></body></html>'
            );
        }
        win.focus();
    }
    websiteMoreInfoClick() {
        window.open('https://www.cardiovascular.abbott', '_blank');
    }
}
